import { globalEntitlements } from './globalEntitlements';

// Service name constants
const BASIC = 'worry_free_service_basic';
const STANDARD = 'worry_free_service';
const ADVANCED = 'worry_free_service_advanced';
const ADVANCED_ADDON = 'worry_free_service_advanced_addon';

/**
 * Gets the appropriate WFC Services buy button configuration using globalEntitlements builder
 * @param {...any} args
 * @returns {object} - Buy button configuration object
 */
export const getWfcServicesBuyButtonConfig = (...args) => {
  const [entitlements, serviceCode] = args;
  const serviceToButtonText = {
    [BASIC]: 'productPage.wfcServices.buyBox.buttonLabel1',
    [STANDARD]: 'productPage.wfcServices.buyBox.buttonLabel2',
    [ADVANCED]: 'productPage.wfcServices.buyBox.buttonLabel3',
  };

  const ctaText = serviceToButtonText[serviceCode] || serviceToButtonText[BASIC];

  const blockingRules = {
    [BASIC]: [BASIC, STANDARD, ADVANCED, ADVANCED_ADDON],
    [STANDARD]: [STANDARD, ADVANCED, ADVANCED_ADDON],
    [ADVANCED]: [BASIC, STANDARD, ADVANCED, ADVANCED_ADDON],
  };

  // Only the Basic-owner case is a genuine "missing prerequisite" — Essential and
  // Advanced Add-on owners already have what they need, they just can't buy this
  // exact SKU standalone, so they get the default tooltip instead.
  const otherBlockingServices = (blockingRules[serviceCode] || []).filter((service) => service !== serviceCode);
  const isMissingPrerequisite = serviceCode === ADVANCED && Boolean(entitlements?.has(BASIC));

  const builder = globalEntitlements({ ctaText })
    .currentProductNotPurchased()
    .blockedByRelatedServices(
      otherBlockingServices,
      isMissingPrerequisite ? 'productPage.common.buyBox.buttonDisabled.tooltip.missingPrerequisite' : undefined,
    );

  return builder.build()(...args);
};
